import React from 'react';
import {swalDeleteForm, swalError, swalChangeAccessType, swalSuccess, swalLoading} from "../utils/swal";
import collaborationService from '../services/collaboration';
import Swal from "sweetalert2";
import PersonIcon from "@material-ui/icons/Person";

export default function Collaborator(props) {

    const handleDelete = id => swalDeleteForm(() => props.deleteCollaborator(id));

    const handleChangeType = id => {
        swalChangeAccessType(async typeId => {
            swalLoading();
            await collaborationService.updateAccessType(id, typeId)
                .then(result => {
                    if (result.error) {
                        Swal.close();
                        swalError(result.error);
                        return;
                    }

                    Swal.close();
                    swalSuccess(`Access type updated successfully!`);
                    props.reload();
                });
        });
    }

    const accessLabel = parseInt(props.collaborator.type) === 1 ? 'Can view' : 'Can edit';

    return (
        <div className="share-collab-item">
            <div className="share-collab-avatar">
                <PersonIcon style={{ fontSize: "20px", color: "#999" }} />
            </div>
            <div className="share-collab-info">
                <span className="share-collab-email">{props.collaborator.email}</span>
                <span className="share-collab-access">{accessLabel}</span>
            </div>
            {props.showDeleteButton === true && (
                <div className="share-collab-actions">
                    <button className="share-collab-action-btn" onClick={() => handleChangeType(props.collaborator._id)}>
                        Change
                    </button>
                    <button className="share-collab-action-btn share-collab-remove-btn" onClick={() => handleDelete(props.collaborator._id)}>
                        Remove
                    </button>
                </div>
            )}
        </div>
    );
}
